import React, { Component, PropTypes } from 'react';
import './Clock.css';

class Clock extends Component {

  render() {
    return (
			<svg className="dateField__icon" xmlns="http://www.w3.org/2000/svg" viewBox="3327.289 274.289 26.222 26.222">
				<path id="Path_58" className="clock" d="M13.111,0A13.111,13.111,0,1,1,0,13.111,13.109,13.109,0,0,1,13.111,0Zm5.951,17.605a.6.6,0,0,0-.124-.838L13.7,12.809v-9.1a.61.61,0,0,0-.6-.6h0a.61.61,0,0,0-.6.6v9.345a.535.535,0,0,0,.1.316.718.718,0,0,0,.192.261l5.429,4.1a.625.625,0,0,0,.852-.124Zm-5.951-16.3A11.805,11.805,0,1,0,24.916,13.111,11.8,11.8,0,0,0,13.111,1.306Z" transform="translate(3327.289 274.289)"/>
			</svg>
    );
  }
}

Clock.propTypes = {
};

export default Clock;



/** WEBPACK FOOTER **
 ** ./src/icons/Clock/index.js
 **/